import { ComponentsOverrides, Theme } from '@mui/material/styles';

export default function MuiAlert(theme: Theme): {
  MuiAlert: { styleOverrides: ComponentsOverrides<Theme>['MuiAlert'] };
} {
  return {
    MuiAlert: {
      styleOverrides: {
        root: {
          display: 'flex',
          alignItems: 'center',
        },
        standardSuccess: {
          color: theme.palette.success.dark,
        },
        standardError: {
          color: theme.palette.error.dark,
        },
        standardWarning: {
          color: theme.palette.warning.dark,
        },
        standardInfo: {
          color: theme.palette.info.dark,
        },
      },
    },
  };
}
